import { render, staticRenderFns } from "./PagesSingle.vue?vue&type=template&id=0ed433e9"
import script from "./PagesSingle.vue?vue&type=script&lang=js"
export * from "./PagesSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports